import { render, staticRenderFns } from "./MyCourses.vue?vue&type=template&id=479fbbba&"
import script from "./MyCourses.vue?vue&type=script&lang=js&"
export * from "./MyCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports